import api from './api';
import BaseFinancialService, { handleApiError } from './financialService';

class ContratoService extends BaseFinancialService {
  constructor() {
    super('/financeiro/contratos');
  }

  // Métodos específicos de contratos
  
  async getStats() {
    try {
      const response = await api.get(`${this.endpoint}/stats/geral`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar estatísticas de contratos');
    }
  }

  async getAlertasRenovacao(dias = 90) {
    try {
      const response = await api.get(`${this.endpoint}/alertas/renovacao`, {
        params: { dias }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar alertas de renovação');
    }
  }

  async uploadAnexo(contratoId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post(
        `${this.endpoint}/${contratoId}/anexos/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao fazer upload do anexo');
    }
  }

  async deleteAnexo(contratoId, anexoId) {
    try {
      const response = await api.delete(`${this.endpoint}/${contratoId}/anexos/${anexoId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao deletar anexo');
    }
  }

  async gerarFatura(contratoId) {
    try {
      const response = await api.post(`/financeiro/receitas/gerar-de-contrato/${contratoId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao gerar fatura do contrato');
    }
  }
}

export default new ContratoService();
